import React from 'react'
import { useTranslation } from 'react-i18next'
import { LinkButton } from '../LinkButton/LinkButton'

interface FilterToggleButtonProps {
    isVisible: boolean
    onToggle: () => void
}

export const FilterToggleButton: React.FC<FilterToggleButtonProps> = ({
    isVisible,
    onToggle,
}) => {
    const { t } = useTranslation('translations')

    return (
        <LinkButton
            name="toggle-filters-visibility"
            iconBefore={isVisible ? 'filter_list' : 'filter_list_off'}
            label={isVisible ? t('filters.hide') : t('filters.show')}
            onClick={onToggle}
        />
    )
}
